export enum WidgetColor {
  GREEN = 'green',
  GOLD = 'gold',
  PINK = 'pink',
  ORANGE = 'orange',
  PURPLE = 'purple',
  TEAL = 'teal',
}

export type WidgetBase = {
  id: WidgetsVariant
  isWidgetVisible: boolean
  imgSrc: string
  imgAlt: string
  onClick?: () => void
}

export type TimerWidget = WidgetBase & {
  timer: string | boolean
  color: WidgetColor
}

export type StaticWidget = WidgetBase & {
  timer?: never
  color?: never
}

export type WidgetConfig = TimerWidget | StaticWidget

export enum WidgetsVariant {
  OFFER = 'offer',
  DAILY_GIFT = 'daily',
  STASH = 'stash',
  REFER_A_FRIEND = 'referFriend',
  PROMO = 'promo',
}
